//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    dance: {
      default: "Waltz",
    },
    currentFigure: {
      default: null,
    },
    allfigures: {
      default: null,
    },
  },
  data() {
    return {
      showPrecedes: true,
      loaded: false,
    };
  },
  watch: {
    currentFigure(val) {
      if (val != null) {
        this.loaded = true;
      }
    },
  },
  computed: {
    levelsInDance() {
      return this.dance === "Viennese Waltz"
        ? ["Bronze", "Silver", "Gold"]
        : ["Newcomer", "Bronze", "Silver", "Gold"];
    },
    precedes() {
      let array = [];
        this.levelsInDance.forEach((level) => {
          let matchedFigures = Object.values(
            this.allfigures[this.dance][level]
          ).filter((figure) => figure.endFoot === this.currentFigure.startFoot);
          let names = [];
          matchedFigures.forEach((figure) => names.push(figure.name));
          array.push(names)
        });
      return array;
    },
    follows() {
      let array = [];
        this.levelsInDance.forEach((level) => {
          let matchedFigures = Object.values(
            this.allfigures[this.dance][level]
          ).filter((figure) => figure.startFoot === this.currentFigure.endFoot);
          let names = [];
          matchedFigures.forEach((figure) => names.push(figure.name));
          array.push(names)
        });
      return array;
    },
  },
};
